import React, { useContext, useEffect, useState, Fragment } from "react";

import {
  Container,
  Accordion,
  Icon,
  Table,
  Button,
  Modal,
  TextArea,
  Form,
  Image
} from "semantic-ui-react";
import VariationStore from "../../../../app/stores/variationStore";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import UserAuthStore from "../../../../app/stores/userauthStore";

import { observer } from "mobx-react-lite";
import { IVariation } from "../../../../app/models/variation";
import { IVariationsor } from "../../../../app/models/variationsor";
import Slider from "react-slick";
import { IVariationphoto } from "../../../../app/models/variationphoto";


interface IProps {}

const WorkOrderVariations: React.FC<IProps> = props => {
  const [activeIndex, setActiveIndex] = useState();
  const [confBoxOpen, setconfBoxOpen] = useState(false);
  const [varImageBoxOpen, setVarImageBoxOpen] = useState(false);
  const [confBoxSorId, setBoxSorId] = useState();
  const [confBoxFunc, setconfBoxFunc] = useState();
  const [VarImageBoxFunc, setVarImageBoxFunc] = useState();
  const [confDeclineRec, setconfDeclineRec] = useState();
  
  //ADD230811 for checking user
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")

  const variationStore = useContext(VariationStore);
  const workorderStore = useContext(oneOrderStore);
  const userauthStore = useContext(UserAuthStore);

  const {
    VariationsRequiringApprovals: requiredApprovalVariations
  } = variationStore;
  const { selectedWorkOrder: currWorkOrder } = workorderStore;
  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const closeModal = () => {
    setconfBoxOpen(false);
  };

  const closeVarModal = () => {
    setVarImageBoxOpen(false);
  };

  const setApprovalStatusConfirmBox = (e: any, data: any) => {
    var id = data.id;
    var func = data.children;
    setBoxSorId(id);
    setconfBoxFunc(func);
    setconfBoxOpen(true);
  };

  const setVariationImagesBox = (e: any) => {
    var id = e;
    setVarImageBoxFunc(e);
    setVarImageBoxOpen(true);
  };

  const createVariationGallery = (e: IVariationphoto[]) => {
    const varPhotos = e.map(ph => <Image src={decodeURIComponent(ph.url)} />);
    return varPhotos;
  };

  const handleChange = (val: any) => {
    setconfDeclineRec(val.target.value);
  };

  const setApprovalStatus = (e: any, data: any) => {
    if( confBoxSorId !== undefined && confBoxFunc !== undefined && confDeclineRec !== undefined) {
    variationStore.setApprovalStatus(
      confBoxSorId,
      confBoxFunc,
      confDeclineRec,
      userauthStore.LoggedInObj!.User.FirstName +
        " " +
        userauthStore.LoggedInObj!.User.LastName
    );
    }
  };

  const getAppStatusColour = (st: string) => {
    if (st.toLowerCase() === "approved")
      return <Icon name="check circle" color="green" size="large" />;
    if (st.toLowerCase() === "rejected")
      return <Icon name="times circle" color="red" size="large" />;
    if (st.toLowerCase() === "pending")
      return <Icon name="stopwatch" size="small" />;
  };

  const getSORRowsForApproval = (vaSors: IVariationsor[]) => {
    var vaSRs = vaSors.map((vr, index) => (
      <Table.Row>
        <Table.Cell>{vr.SORDescripion}</Table.Cell>
        <Table.Cell>{vr.SORQty}</Table.Cell>
        <Table.Cell>{vr.SORValue}</Table.Cell>
        <Table.Cell>{vr.VarComment}</Table.Cell>
        <Table.Cell>{vr.ApprovalStatus}</Table.Cell>
        <Table.Cell>{vr.ApprovedDeclinedBy}</Table.Cell>
        <Table.Cell>
          {vr.ApprovalStatus.toLowerCase() === "pending" ||
          vr.ApprovalStatus === null ? (
            <div>
              <Button
                id={vr.VarSorId}
                size="mini"
                color="green"
                onClick={setApprovalStatusConfirmBox}
              >
                Approve SOR
              </Button>
              <Button
                id={vr.VarSorId}
                size="mini"
                color="red"
                onClick={setApprovalStatusConfirmBox}
              >
                Decline SOR
              </Button>
            </div>
          ) : (
            getAppStatusColour(vr.ApprovalStatus)
          )}
        </Table.Cell>
      </Table.Row>
    ));

    return vaSRs;
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    adaptiveWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const showActiveVarRequests = (vars: IVariation[]) => {
    if (vars !== null) {
      var varHist = vars.map((vr, index) => (
        <Fragment>
          <Accordion.Title
            active={activeIndex === index}
            index={index}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            {getAppStatusColour(vr.AppStatus)} <b> {vr.Name} </b>{" "}
            <div style={{ float: "right" }}>
              <Icon name="pound sign" />
              {vr.Value}
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <div
              className="ag-theme-material"
              style={{ height: "200px", width: "100%" }}
            >
              <Button
                icon
                labelPosition="left"
                onClick={() => setVariationImagesBox(vr.Name)}
              >
                <Icon name="photo" />
                Variation Photos
              </Button>

              <Table unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>SOR</Table.HeaderCell>
                    <Table.HeaderCell>Qty</Table.HeaderCell>
                    <Table.HeaderCell>Value</Table.HeaderCell>
                    <Table.HeaderCell>Comments</Table.HeaderCell>
                    <Table.HeaderCell>Approval Status</Table.HeaderCell>
                    <Table.HeaderCell>Approver</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{getSORRowsForApproval(vr.VarSors)}</Table.Body>
              </Table>
            </div>
          </Accordion.Content>

          <Modal dimmer={"blurring"} open={confBoxOpen}>
            <Modal.Header>{confBoxFunc} - Are you sure?</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                {confBoxFunc === "Approve SOR" ? (
                  <p>Are you sure you would like to approve this SOR?</p>
                ) : (
                  <div>
                    <p>
                      Rejecting any line will reject the entire variation.
                      Please ensure you have approved all other SORs that are
                      correct to help us deal with this rejection more
                      efficiently.
                    </p>

                    <h4>Decline Reason</h4>
                    <Form>
                      <TextArea
                        placeholder="Please complete a reason for the decline"
                        onChange={handleChange}
                      />
                    </Form>
                  </div>
                )}
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              {variationStore.settingapproval === true ? (
                <Button color="green" loading onClick={setApprovalStatus}>
                  {confBoxFunc}
                </Button>
              ) : (
                <Button color="green" onClick={setApprovalStatus}>
                  {confBoxFunc}
                </Button>
              )}

              <Button color="red" onClick={closeModal}>
                Cancel
              </Button>
            </Modal.Actions>
          </Modal>

          <Modal
            dimmer={"blurring"}
            open={varImageBoxOpen}
            onClose={closeVarModal}
            closeIcon
          >
            <Modal.Header>Variation Images</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                Please check the following Variation Images
              </Modal.Description>

              <Slider {...settings}>
                {createVariationGallery(vr.VarPhotos)}
              </Slider>
            </Modal.Content>
          </Modal>
        </Fragment>
      ));
      return varHist;
    }
  };

  useEffect(() => {
    var id = currWorkOrder!.JobId;
    //changed with username
    variationStore.loadWorkOrderVariations(id, sessionObj.User.Username);
    showActiveVarRequests(requiredApprovalVariations);
  }, [currWorkOrder]);

  useEffect(() => {
    if (variationStore.VariationResponse !== undefined) {
      closeModal();
      if ((variationStore.VariationResponse.IsCompleted === true) ) {
        variationStore.VariationsRequiringApprovals = [];
        variationStore.selectedWorkOrder = undefined;
        variationStore.VariationResponse = undefined;
        window.location.reload();
      } else {
        //changed with username
        variationStore.loadWorkOrderVariations(currWorkOrder!.JobId, sessionObj.User.Username);
        variationStore.VariationResponse = undefined;
      }
    }
  }, [variationStore.VariationResponse]);

  return (
    <Container>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <Accordion fluid styled>
          {showActiveVarRequests(requiredApprovalVariations)}
        </Accordion>
      </div>
    </Container>
  );
};

export default observer(WorkOrderVariations);
